"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils_1 = require("@0x/utils");
/**
 * A altered version of the base class Subprovider found in [web3-provider-engine](https://github.com/MetaMask/provider-engine).
 * This one has an async/await `emitPayloadAsync` and also defined types.
 */
var Subprovider = /** @class */function () {
  function Subprovider() {}
  Subprovider._createFinalPayload = function (payload) {
    var finalPayload = __assign({
      // defaults
      id: Subprovider._getRandomId(),
      jsonrpc: '2.0',
      params: []
    }, payload);
    return finalPayload;
  };
  // Ported from: https://github.com/MetaMask/provider-engine/blob/master/util/random-id.js
  Subprovider._getRandomId = function () {
    var extraDigits = 3;
    var baseTen = 10;
    // 13 time digits
    var datePart = new Date().getTime() * Math.pow(baseTen, extraDigits);
    // 3 random digits
    var extraPart = Math.floor(Math.random() * Math.pow(baseTen, extraDigits));
    // 16 digits
    return datePart + extraPart;
  };
  /**
   * Emits a JSON RPC payload that will then be handled by the ProviderEngine instance
   * this subprovider is a part of. The payload will cascade down the subprovider middleware
   * stack until finding the responsible entity for handling the request.
   * @param payload JSON RPC payload
   * @returns JSON RPC response payload
   */
  Subprovider.prototype.emitPayloadAsync = function (payload) {
    return __awaiter(this, void 0, void 0, function () {
      var finalPayload, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            finalPayload = Subprovider._createFinalPayload(payload);
            return [4 /*yield*/, utils_1.promisify(this.engine.sendAsync, this.engine)(finalPayload)];
          case 1:
            response = _a.sent();
            return [2 /*return*/, response];
        }
      });
    });
  };
  /**
   * Set's the subprovider's engine to the ProviderEngine it is added to.
   * This is only called within the ProviderEngine source code, do not call
   * directly.
   * @param engine The ProviderEngine this subprovider is added to
   */
  Subprovider.prototype.setEngine = function (engine) {
    this.engine = engine;
  };
  return Subprovider;
}();
exports.Subprovider = Subprovider;